var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "BasePageLayout",
    [
      _c("template", { slot: "page__title" }, [
        _c("div", { staticClass: "ellipsis-one-line" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$vuetify.lang.t(
                  "$vuetify.SYSTEM_SETTING.BASIC_SETTINGS.TITLE"
                )
              ) +
              " "
          ),
        ]),
      ]),
      _c(
        "v-tabs",
        {
          attrs: { centered: "", "show-arrows": "" },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _vm._l(_vm.listTabs, function (tab) {
            return _c("v-tab", { key: tab.value }, [_vm._v(_vm._s(tab.title))])
          }),
          _vm._l(_vm.listTabs, function (tab) {
            return _c(
              "v-tab-item",
              { key: tab.value },
              [
                _c(
                  "v-card",
                  { staticClass: "px-8", attrs: { flat: "" } },
                  [_c(_vm.currentComponent, { tag: "component" })],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }